import * as React from "react";
import classnames from "classnames";
import { Flyout } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
/* empty css                        */
import { getLocaleSwitcherData } from "../utils/LocaleSwitcherMenu/utils/get-locale-switcher-data.js";
import { getLocaleSwitcherMenuLabel } from "../utils/LocaleSwitcherMenu/utils/get-locale-switcher-menu-label.js";
import { getLocaleSwitcherMenuTitle } from "../utils/LocaleSwitcherMenu/utils/get-locale-switcher-menu-title.js";
const createSubMenu = (items) => items.map((item, index) => /* @__PURE__ */ React.createElement(
  Flyout.MenuItem,
  {
    key: item.label || index,
    link: item?.link?.href,
    action: item?.parameters?.action
  },
  item.label
));
const LocaleSwitcherMenu = ({ availableLocales, className }) => {
  const intl = useIntl();
  const localeSwitcherData = getLocaleSwitcherData(availableLocales, true);
  const menuLabel = getLocaleSwitcherMenuLabel(intl.locale);
  const menuTitle = getLocaleSwitcherMenuTitle(availableLocales, intl.locale, menuLabel);
  return /* @__PURE__ */ React.createElement(Flyout, null, /* @__PURE__ */ React.createElement(
    Flyout.Trigger,
    {
      className: classnames("locale-switcher-menu__button--link header-menu__icon", className),
      title: menuTitle
    },
    menuLabel
  ), /* @__PURE__ */ React.createElement(Flyout.Menu, null, createSubMenu(localeSwitcherData)));
};
export {
  LocaleSwitcherMenu,
  LocaleSwitcherMenu as default
};
//# sourceMappingURL=LocaleSwitcherMenu.js.map
